import axios from 'axios'
import {
  fetchAwsDimensionsCategoriesListUrl,
  fetchCountriesListS3Url,
} from '../utils/constants'

export const fetchAwsCountriesList = () => axios.get(fetchCountriesListS3Url)

export const fetchAwsDimensionsCategoriesList = () =>
  axios.get(fetchAwsDimensionsCategoriesListUrl)
